if (!customElements.get("product-upsell")) {
  customElements.define(
    "product-upsell",
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.upsellData = this.getUpsellData();
        this.upsellEl = this.querySelector(".product-upsell");
        this.variantSelect = this.querySelector("variant-selects");

        document.body.addEventListener(
          "variantChange",
          this.handleVariantChange.bind(this),
        ); //user changes main product variant

        this.atc = JSON.parse(this.getAttribute("data-atc"));

        if (!this.atc) {
          this.addEventListener("click", this.handleUpsellClick.bind(this)); //delegate to parent

          this.addEventListener("change", this.updateVariantInput.bind(this));
        } else {
          //ATC SPECIFIC STUFF

          this.addEventListener("change", this.updateUpsellId.bind(this));
        }
      }

      handleUpsellClick(e) {
        if (e.target.closest(".product-upsell__image")) {
          const upsell_item = e.target.closest(".product-upsell__item");
          if (!upsell_item) return;

          this.showUpsellForm(upsell_item);

          this.getCurrentSetForm(upsell_item);
        }

        if (e.target.closest(".product-upsell__close")) {
          this.closeCurrentUpsell();
        }
      }

      handleVariantChange() {
        //data-color-current has been changed by variant
        const upsell_item = this.querySelector(".product-upsell__item.in-view");

        var current_location =
          document.querySelector("main")?.dataset.location ?? "en";
        var current_currency =
          document.querySelector("main")?.dataset.currency ?? "AUD";

        var money = new Intl.NumberFormat(current_location, {
          style: "currency",
          currency: current_currency,
          currencyDisplay: "narrowSymbol",
        });

        if (upsell_item) {
          this.getCurrentSetForm(upsell_item);
        }

        //set prices of all upsell
        const all_upsells = this.upsellEl.querySelectorAll(
          ".product-upsell__item",
        );
        var current_color = this.upsellEl.dataset.colorCurrent;

        this.upsellData.forEach((product, index) => {
          for (let i = 0; i < product.length; i++) {
            const variant = product[i];
            var lower_title = variant.title.toLowerCase();
            if (lower_title.includes(current_color)) {
              let upsell_item = all_upsells[index];

              //set price of current index
              let price = upsell_item.querySelector(".upsell_price");

              price.innerHTML = money.format(variant.price / 100);

              if (this.atc) {
                //if product has atc, set variant id
                console.log(variant, upsell_item);

                //Check to see if upsell item has variants
                var upsell_select = upsell_item.querySelector(
                  ".product-upsell__variant",
                );

                let variant_input = upsell_item.querySelector(
                  'product-form input[name="id"]',
                );
                variant_input.value = variant.id;

                //Variant select needs to pick the previous matching value
                var newly_selected_option = upsell_item.querySelector(
                  `[data-title="${variant.title}"]`,
                );

                if (newly_selected_option) {
                  newly_selected_option.selected = true;

                  if (variant.available) {
                    this.enableATC(upsell_item);
                  } else {
                    this.disableATC(upsell_item);
                  }
                }
              }
              break;
            }
          }
        });
      }

      getUpsellData() {
        this.upsellData =
          this.upsellData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );

        return this.upsellData;
      }

      getMatchedVariants(data, colorIndex) {
        //THIS IS BROKEN FOR PRODUCTS WITH NO VARIANTS!
        // Its not broken, if variant doesn't have matching color, what to do?
        // Have nothing preselected and show all variants -> not only default

        //loop through variants to find matching items (same as current color)
        let matched = data.filter((variant) => {
          let current_option = variant.options[colorIndex];
          if (
            current_option &&
            current_option.toLowerCase() == this.upsellEl.dataset.colorCurrent
          ) {
            return variant;
          }
        });
        return matched;
      }

      //returns matched upsell variant data from given upsell-item
      getCurrentSetForm(upsell_item) {
        const form_el = upsell_item.querySelector(".product-upsell__form");
        if (!form_el) return;

        this.getUpsellData();

        if (!this.upsellData) return;

        const clicked_product_data =
          this.upsellData[parseInt(upsell_item.dataset.index)];

        if (!clicked_product_data) return;

        const color_index = upsell_item.dataset.colour; //colour index based on indiv variant items

        const matches = color_index
          ? this.getMatchedVariants(clicked_product_data, parseInt(color_index))
          : clicked_product_data;

        this.setFormData(form_el, matches, upsell_item);
      }

      setFormData(form, data, item) {
        // const title = form.querySelector('.title')
        // const price = form.querySelector('.price')
        const variants = form.querySelector(
          ".product-form__input .product-form--radios",
        );
        const only_default = item.dataset.onlyDefault == "true";
        const color_index = parseInt(item.dataset.colour);

        var current_currency =
          document.querySelector("main")?.dataset.currency ?? "AUD";

        var money = new Intl.NumberFormat(current_location, {
          style: "currency",
          currency: current_currency,
          currencyDisplay: "narrowSymbol",
        });

        // if(!title || !price) return

        const pill_template = `
                <div class="product-form--radio">
                    <input id="{2}" type="radio" name="items[1][id]" value="{1}" {3}>
                    <label for="{2}">{0}</label>
                </div>
            `;

        const option_template = `<option {3} value="{1}">{0}</option>`;

        let variant_pills = "";

        // NOTE - handle color index dynamically, option title

        if (data.length > 8 || data[0].options.length == 3) {
          //more than 8 variants or 3 options
          var options = "";
          data.forEach((variant, index) => {
            var disabled = !variant.available ? "disabled" : "";
            options =
              options +
              option_template
                .replace("{0}", variant.name)
                .replace("{1}", variant.id)
                .replace("{3}", disabled);
          });

          variant_pills = `<div class="select"><select class="select__select" name="items[1][id]">${options}</select></div>`;
        } else if (data.length > 1) {
          //has multiple variants > display non-color options
          const color_index = !parseInt(item.dataset.colour); //opposite of the colour index
          data.forEach((variant, index) => {
            var disabled = !variant.available ? "disabled" : "";
            variant_pills =
              variant_pills +
              pill_template
                .replace("{0}", variant.options[1])
                .replace("{1}", variant.id)
                .replaceAll("{2}", variant.id + "--" + index)
                .replace("{3}", disabled);
          });
        } else {
          //only colour
          let pill_html = only_default ? "" : '<label for="{2}">{0}</label>';
          variant_pills =
            `<div class="product-form--radio"><input type="radio" name="items[1][id]" id="{2}" value="{1}" checked>${pill_html}</div>`
              .replace("{0}", data[0].options[0])
              .replace("{1}", data[0].id)
              .replaceAll("{2}", data[0].id + "--0");
        }
        // var title_copy = item.dataset.onlyDefault == 'true' ? '' : " - " + data[0].options[parseInt(this.upsellEl.dataset.colorIndex)]
        // title.innerHTML = item.dataset.productTitle + title_copy
        // price.innerHTML = money.format(data[0].price/100)
        variants.innerHTML = variant_pills;

        if (data.length == 1) {
          //trigger change on radio to add array-obj id inputs
          variants
            .querySelector("input")
            .dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      showUpsellForm(item) {
        this.closeCurrentUpsell();
        this.upsellEl.classList.add("active");
        item.classList.add("in-view");
      }

      updateVariantInput(e) {
        if (!e.target.closest(".product-upsell__item")) return;

        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');

          const product_personaliser = productForm.querySelector(
            ".product-personalizer",
          );

          if (input && !product_personaliser) {
            //set single input to array-obj style
            input.name = "items[0][id]";

            //check for properties
            var property_inputs = productForm.querySelectorAll(
              'input[name*="properties"]',
            );

            Array.from(property_inputs).forEach((input) => {
              var current_name = input.name;
              var new_name = `items[0][properties]${current_name.replace("properties", "")}`; //brackets included
              input.name = new_name;
            });

            input.dispatchEvent(new Event("change", { bubbles: true }));
          }

          const upsell_input = productForm.querySelector(
            'input[name="items[1][id]"]',
          );

          if (upsell_input) {
            // already has upsell, change variant ID
            upsell_input.value = e.target.value;
          } else {
            let new_upsell_input = document.createElement("input");
            new_upsell_input.type = "hidden";
            new_upsell_input.name = "items[1][id]";
            new_upsell_input.value = e.target.value;
            productForm.append(new_upsell_input);
          }
          // input.value = this.currentVariant.id;
          // input.dispatchEvent(new Event('change', { bubbles: true }));

          /*

                TODO
                    - Out of stock upsell, don't add
                    - Remove product, remove hidden input
                */
        });
      }

      closeCurrentUpsell() {
        const current_inview = this.querySelector(
          ".product-upsell__item.in-view",
        );

        if (current_inview) {
          current_inview.classList.remove("in-view");
        }

        this.upsellEl.classList.remove("active");
      }

      updateUpsellId(e) {
        var changed_upsell = e.target.closest(".product-upsell__item");
        var input_value = e.target.value;

        if (!changed_upsell || !input_value) {
          this.disableATC(changed_upsell);
          return;
        }

        var id_input = changed_upsell.querySelector('input[name="id"]');

        if (!id_input) {
          this.disableATC(changed_upsell);
          return;
        }

        //check if product is available
        let available_string = e.target.selectedOptions[0].dataset.available;
        let available = JSON.parse(available_string);
        if (available) {
          this.enableATC(changed_upsell);
        } else {
          this.disableATC(changed_upsell);
        }

        id_input.value = input_value;
      }

      disableATC(upsell_item) {
        const submit_button = upsell_item.querySelector(".quick-add__submit");

        if (!submit_button) return;

        const soldOutMessage = submit_button.querySelector(".sold-out-message");

        if (soldOutMessage) {
          submit_button.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
        }

        submit_button.setAttribute("aria-disabled", true);
        submit_button.setAttribute("disabled", "disabled");
      }

      enableATC(upsell_item) {
        const submit_button = upsell_item.querySelector(".quick-add__submit");

        if (!submit_button) return;

        const soldOutMessage = submit_button.querySelector(".sold-out-message");

        if (soldOutMessage) {
          submit_button.querySelector("span").classList.remove("hidden");
          soldOutMessage.classList.add("hidden");
        }

        submit_button.setAttribute("aria-disabled", false);
        submit_button.removeAttribute("disabled");
      }
    },
  );
}
